// @boty/ui - Theme exports
// MUI theme configuration with Boty branding

import { createTheme, type Theme } from '@mui/material/styles';
import { palette } from './palette';
import { typography } from './typography';
import { components } from './components';

export type Direction = 'ltr' | 'rtl';

export interface CreateBotyThemeOptions {
  direction?: Direction;
}

/**
 * Creates a Boty-branded MUI theme with RTL support
 * @param options - Theme options including direction ('ltr' | 'rtl')
 * @returns MUI Theme object
 */
export function createBotyTheme(options: CreateBotyThemeOptions = {}): Theme {
  const { direction = 'ltr' } = options;

  return createTheme({
    direction,
    palette,
    typography: typography ?? {},
    spacing: 8, // Base unit: 8px
    shape: {
      borderRadius: 8, // Default for most components
    },
    components,
  });
}

// Re-export palette, typography, and components for advanced customization
export { palette } from './palette';
export { typography } from './typography';
export { components } from './components';

// Re-export commonly used MUI types
export type { Theme, ThemeOptions } from '@mui/material/styles';

// Re-export RTL utilities
export {
  CSS_LOGICAL_PROPERTIES,
  getAnimationDirection,
  createSlideInKeyframes,
  getRtlFlexAlignment,
  RTL_STYLE_GUIDE,
} from './rtl';
